// extracted by mini-css-extract-plugin
export default {"applicantTable":"ApplicantList_applicantTable__6K6Tm","tbody":"ApplicantList_tbody__mw8Iv","applicantTableRow":"ApplicantList_applicantTableRow__rOwsq"};